<template>
  <v-container id="customers-page-database">
    <v-row>
      <v-col cols="12" class="text size-large weight-bold font-alt">
        Découvrez et ciblez votre base
      </v-col>
    </v-row>
    <v-row class="px-3 mt-8">
      <v-col cols="12" class="colored-bg">
        <v-row class="pa-3">
          <!-- <v-col cols="12">
            <div id="search-zone" class="colored-bg-dark px-16 py-3">
              <v-text-field
                v-model="searchFilter"
                class="mx-16"
                solo
                label="Rechercher"
                hide-details
                prepend-inner-icon="search"
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col
                class="pr-1"
                cols="2"
                v-for="(category, index) in categories"
                :key="index"
              >
                <category-details
                  @click="selectSegment(category.code)"
                  selectable
                  :code="category.code"
                  :color="category.color"
                  :label="category.label"
                  :description="category.description"
                />
              </v-col>
            </v-row>
          </v-col> -->
          <v-col cols="12">
            <div class="up-table">
              <div class="text size-medium color-black-base">
                Vos inscrits
              </div>
              <div>
                <button
                  class="simple-action-button"
                  @click="$refs.file.click()"
                >
                  importer des clients
                </button>
                <button class="simple-action-button" @click="downloadExample()">Télécharger un fichier exemple</button>

                <!-- <button class="simple-action-button" @click="exportCustomers()">
                  Exporter
                </button> -->
              </div>
              <input
                type="file"
                id="clients-input-files"
                accept=".csv"
                ref="file"
                hidden
                @change="onFileChange"
              />
            </div>
          </v-col>
          <!-- @click.stop="drawer = !drawer" -->
          <v-col cols="12" class="pt-0">
            <table-users @display-detail="displayDetail" />
          </v-col>
        </v-row>
        <v-row> </v-row>
      </v-col>
    </v-row>
    <!--<modal
      :component="CustomerDetail"
      v-if="!!item"
      :values="{ item }"
      @close="close()"
    ></modal>-->

    <Drawer :item="item" ref="drawer-customers" />
  </v-container>
</template>

<script type="text/javascript">
import categoryDetails from '@/components/cards/category-details';
import kpiTrend from '@/components/cards/kpi-trend';
import chartLine from '@/components/charts/chart-line';
import Drawer from '@/components/ui/drawer.vue';
import tableUsers from './table-users';
import Modal from '@/components/modal/modal.vue';
import CustomerDetail from './customer-detail.vue';
export default {
  components: {
    chartLine,
    kpiTrend,
    categoryDetails,
    tableUsers,
    Drawer,
    Modal,
    CustomerDetail,
  },
  props: {},
  data() {
    return {
      itemNb: 10,
      item: null,
      fileinput: '',
      showDrawer: false,
      CustomerDetail,
    };
  },
  computed: {
    kpiTrends() {
      return this.$store.state.userOverview.kpiTrends;
    },
    optInHistory() {
      return this.$store.state.userOverview.optInHistory;
    },
    categories() {
      return this.$store.state.userOverview.categories;
    },
    searchFilter: {
      get() {
        return this.$store.state.customer.customerFilters.search;
      },
      set(value) {
        this.$store.commit('userOverview/setDbFilterSearch', value);
      },
    },
  },
  methods: {
    close() {
      this.item = null;
    },
    displayDetail(item) {
      this.item = item;
      this.$refs['drawer-customers'].openDrawer();
    },
    closeDrawer() {
      this.showDrawer = false;
    },
    exportCustomers() {
      this.$store.commit('ui/cloader', {
        display: true,
        label: 'Exportation en cours',
      });
      this.$store.dispatch('customer/exportAllCustomers');
    },
    selectSegment(code) {
      this.$store.commit('customer/setDbFilterSegments', code);
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createInput(files[0]);
    },
    createInput(file) {
      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        self.$store.dispatch('customer/importClientsFromCsv', reader.result);
      };
      reader.readAsText(file);
    },
    downloadExample() {
      const text = `prenom;nom;email;phone;segments
John;DOE;john.doe@mail.com;"+33677666666";25-35;HOMME;PARIS`
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', 'import-template.csv');

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  },
  created() {
    this.$store.dispatch('customer/loadCustomerData');
  },
  beforeDestroy() {
    this.$eventHub.$off('openDrawer');
  },
};
</script>

<style lang="scss">
.up-table {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#customers-page-database {
  #search-zone {
    box-shadow: 0.3px 3px 10px 0 rgba(119, 119, 119, 0.1);
    .v-input {
      .v-input__slot {
        box-shadow: none !important;
      }
    }
  }
}

.simple-action-button {
  padding: 8px;
  background: white;
  position: relative;
  border-radius: 5px;
  float: right;
  margin: 8px;
  box-shadow: 0 0 3px #b3a4a487;
  transition: all 0.3s;
  &:hover {
    background: #f9f6f6;
  }
  &:active {
    background: #e5e5ee;
  }
}
</style>
